<!--巡回日报  -->
<template>
	<div class="info-box">
		<el-dialog title="客商销售台账信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle"
			top="3vh">
			<div>
						<div class="info-title">客商信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 客商信息: </span>
									<span class="ml15"> {{rowData.agentCode ||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 客商名称: </span>
									<span class="ml15"> {{rowData.agentName||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 销售周期: </span>
									<span class="ml15"> {{rowData.weekName ||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 销售范围: </span>
									<span class="ml15"> {{rowData.skuNames ||'无'}}</span>
								</div>
							</div>
							<!--  -->
						
							<!--  -->
						</div>

					</div>
				<!--  -->
					<!-- 销售台账 -->
			
				<div class="info-title mt20">销售台账:</div>
				<el-table class="mt20" :data="tableData"  ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					max-height="300px" border style="width: 100%">
					 <el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index"
						:show-overflow-tooltip="true" :label="value" :min-width="100">
						<template slot-scope="scope">
							{{scope.row[index]}}
						</template>
					</el-table-column>
				</el-table>
			
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'

	export default {
		components: {
			
		},
		data() {
			return {
				dialogVisible: false,
				rowData: {},
				tableData: [],
				agentId:"",
				titles:[],
				planDate:[]
			}
		},
		created() {

		},
		methods: {
			init(data,planDate) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.rowData = {}
					this.planDate=planDate?planDate:[]
					if (data) {
						this.agentId = data.dataKey
						this.getInfo()
					}

				})


			},
			
			// 查询
			getInfo() {
				let that = this;
				that.$request.post(
						"saleStaticsInfo",
						false, {
							agentId: that.agentId,
							dateStart: that.planDate?that.planDate[0]:"",
							dateEnd: that.planDate?that.planDate[1]:"",
						}
					)
					.then((res) => {
						if (res) {
							that.rowData=res.data
							that.tableData = res.data.contents
							that.titles = res.data.header?res.data.header.split(","):[]
						}
					})
			},
		
			
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$emit("getList")
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			// height: 330px;
			padding: 20px 20px 10px;
			overflow-y: auto;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}
	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
		color: #999;
	}
</style>
